module.exports = __webpack_public_path__ + "static/media/switch_on.2b02e163.png";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/BooleanState/img/switch_on.png
// module id = 581
// module chunks = 0